import { Easing } from "@tweenjs/tween.js"
import Timings from "game/Timings"
import {
    DRIFT_ROTATION_RADIANS,
    DRIFT_TARGET,
    HALF_SEPARATION_DISTANCE,
    SEPARATION_DISTANCE
} from "./settings"

const {
    ROCKET_STAGE_DRIFT_DURATION,
    ROCKET_STAGE_SEPARATION_DELAY,
    ROCKET_STAGE_SEPARATION_DURATION
} = Timings

export function getSeparation(rocket) {
    const { secondStage, thirdStage } = rocket

    const sharedProperties = {
        delay: ROCKET_STAGE_SEPARATION_DELAY,
        duration: ROCKET_STAGE_SEPARATION_DURATION,
        easing: Easing.Exponential.Out
    }

    const props3 = {
        y: thirdStage.y - HALF_SEPARATION_DISTANCE
    }

    const props2 = {
        y: secondStage.y + HALF_SEPARATION_DISTANCE
    }

    return {
        sharedProperties,
        props3,
        props2
    }
}

export function getDrift(rocket) {
    const { secondStage } = rocket

    return {
        duration: ROCKET_STAGE_DRIFT_DURATION,
        x: secondStage.x + DRIFT_TARGET.x,
        y: secondStage.y + DRIFT_TARGET.y,
        rotation: secondStage.rotation + DRIFT_ROTATION_RADIANS
    }
}

export function getDriftLoop(rocket) {
    const { secondStage } = rocket

    return {
        duration: ROCKET_STAGE_DRIFT_DURATION,
        x: secondStage.x + DRIFT_TARGET.x,
        y: secondStage.y + DRIFT_TARGET.y,
        rotation: secondStage.rotation + DRIFT_ROTATION_RADIANS
    }
}
